import { useTranslate } from "@refinedev/core";
import { SettingsTileCard } from "@fawkes/ui";

import type { TileComponentProps } from "./types";

// Voeding — de producten voor voedingsplannen (brok, natvoer, vocht met kcal), per vestiging of voor alle locaties
// (Maarten, 2026-10-09). Opent het beheerscherm VoedingSettings in de context van het dashboard.
export const VOEDING_TILE_KEY = "voeding";

const ITEM_KEYS = [
  "instellingen.item.voeding.producten",
  "instellingen.item.voeding.kcal",
  "instellingen.item.voeding.locatie",
];

export function VoedingTile({ onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  return (
    <SettingsTileCard
      tileKey={VOEDING_TILE_KEY}
      icon={
        <svg className="settings-tile-icon" width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 11h18a9 9 0 0 1-18 0Z" /><path d="M8 7c0-1.5 1-2 1-3.5M12 7c0-1.5 1-2 1-3.5M16 7c0-1.5 1-2 1-3.5" />
        </svg>
      }
      title={t("instellingen.tile.voeding.title")}
      description={t("instellingen.tile.voeding.desc")}
      items={ITEM_KEYS.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("voeding")}
    />
  );
}
